import React from 'react';

const SVGArrow = props => {
  const classNames = [
    'svg',
    'svg--stroke',
    'svg--square-stroke',
    'svg--inline-block',
    ...(props.classNames || [])
  ];
  return (
    <div className={classNames.join(' ')}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 11">
        <title>Arrow</title>
        <path d="M28,5.5H1" />
        <path d="M5.55.6c-.61,1.9-2.27,3.54-5,4.9a9.22,9.22,0,0,1,5,4.89" />
      </svg>
    </div>
  );
};

export default SVGArrow;



// WEBPACK FOOTER //
// ./src/svg/Arrow.js